export default {"src":"/_next/static/media/barbeque.c40bbc92.svg","height":91,"width":185,"blurWidth":0,"blurHeight":0};